import { Typography, Box, Divider, List, ListItem } from "@mui/material";

export const RenderChangeSummary = (props: any) => {
    const { changes } = props;
  return (
    <Box>
      {changes.created?.length > 0 && (
        <>
          <Typography variant="subtitle1" color="green">Added KPIs</Typography>
          <List dense>
            {changes.created.map((item: any, idx: number) => (
              <>
{item.area &&  <h6> Sub Category - {item.area} </h6>}
<ListItem key={idx}>
                <Box display="flex" flexDirection="column" gap={1}>
                  <Typography variant="body2"><b>Kpi Name</b> -- {item.kpiName} - <b>Kpi  Unit</b> {item.kpiUnit}</Typography>
                  <Typography variant="body2"><b>Kpi Tag</b></Typography>
                    {Array.isArray(item.kpitag) ? item.kpitag.map((tag: string, index: number) => (
                      <Typography key={index} variant="body2">{tag}</Typography>
                    )) : <Typography>{item.kpitag}</Typography>}
                 
                </Box>
                </ListItem></>
            ))}
          </List>
          <Divider sx={{ my: 1 }} />
        </>
      )}

      {changes.deleted?.length > 0 && (
        <>
          <Typography variant="subtitle1" color="error">Removed KPIs</Typography>
          <List dense>
            {changes.deleted.map((item: any, idx: number) => (
              <>
               {item.area &&  <h6> Sub Category - {item.area} </h6>}
                <ListItem key={idx}>
                <Box display="flex" flexDirection="column" gap={1}>
                  <Typography variant="body2"><b>Kpi Name</b> -- {item.kpiName} - <b>Kpi  Unit</b> {item.kpiUnit}</Typography>
                  <Typography variant="body2"><b>Kpi Tag</b></Typography>
                    {Array.isArray(item.kpitag) ? item.kpitag.map((tag: string, index: number) => (
                      <Typography key={index} variant="body2">{tag}</Typography>
                    )) : <Typography>{item.kpitag}</Typography>}
                 
                </Box>
                </ListItem></>
            ))}
          </List>
          <Divider sx={{ my: 1 }} />
        </>
      )}

      {changes.updated?.length > 0 && (
        <>
          <Typography variant="subtitle1" color="orange">Modified KPIs</Typography>
          <List dense>
            {changes.updated.map((item: any, idx: number) => (
              <>
               {item.from.area &&  <h6> Sub Category - {item.from.area} </h6>}
              <ListItem key={idx}>
                <strong>{item.from.kpiName}</strong> - changed unit from {item.from.kpiUnit} to {item.to.kpiUnit}
              </ListItem></>
            ))}
          </List>
        </>
      )}

{changes.reordered?.length > 0 && (
        <>
          <Typography variant="subtitle1" color="info.main">Reordered KPIs</Typography>
          <List dense>
            {changes.reordered.map((item: any, idx: number) => (
              <>
              {item.kpi.area &&  <h6> Sub Category - {item.kpi.area} </h6>}
              <ListItem key={idx}>
                <strong>{item.kpi.kpiName}</strong> - moved from position {item.fromIndex + 1} to {item.toIndex + 1}
              </ListItem></>
            ))}
          </List>
        </>
      )}
    </Box>
  );
};
